export default __webpack_public_path__ + "static/media/school-one.062a1d9c.png";